export default __webpack_public_path__ + "static/media/img_introduce_jobda_1.ebfc4c37.png";